// Accounts whose page loads and API calls are always traced in Sentry (everyone else keeps the
// default sample rate). The pageload trace starts before sign-in finishes, so the decision is
// remembered in this browser at sign-in and read on later visits; the server follows the
// browser's decision through the trace headers.
const BENCHMARK_EMAILS = ["max@goodmachine.ai", "max.kendrick@gmail.com"];
const KEY = "benchmarkTrace";

export function rememberBenchmarkAccount(email: string | null | undefined) {
  try {
    if (email && BENCHMARK_EMAILS.includes(email.trim().toLowerCase())) localStorage.setItem(KEY, "1");
    else localStorage.removeItem(KEY);
  } catch { /* storage unavailable: default sampling */ }
}

export function benchmarkTraceRate(defaultRate: number): number {
  try { return localStorage.getItem(KEY) === "1" ? 1 : defaultRate; } catch { return defaultRate; }
}
